const HomeFixedIcon = () => (
  <svg viewBox='0 0 24 24' className='h-[22px] w-[22px]' aria-hidden>
    <path
      d='M4 10L12 3l8 7v10a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1V10z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.8'
      strokeLinejoin='round'
    />
  </svg>
);
export default HomeFixedIcon;
